import { RedirectComponent } from './redirect/redirect.component';
import { SolicitarNovaSenhaComponent } from './solicitar-nova-senha/solicitar-nova-senha.component';
import { RecuperarSenhaComponent } from './recuperar-senha/recuperar-senha.component';

import { CriarProdutoComponent } from './produtos/criar-produto/criar-produto.component';
import { ProdutosComponent } from './produtos/produtos.component';
import { ClientesComponent } from './clientes/clientes.component';
import { AtualizarPermissaoComponent } from './permissao/atualizar-permissao/atualizar-permissao.component';
import { CriarPermissaoComponent } from './permissao/criar-permissao/criar-permissao.component';
import { PermissaoComponent } from './permissao/permissao.component';
import { AtualizarGrupoComponent } from './grupos/atualizar-grupo/atualizar-grupo.component';
import { CriarGrupoComponent } from './grupos/criar-grupo/criar-grupo.component';
import { GruposComponent } from './grupos/grupos.component';
import { AtualizarUsuarioComponent } from './usuarios/atualizar-usuario/atualizar-usuario.component';

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { ConfiguracaoComponent } from './configuracao/configuracao.component';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { CriarUsuarioComponent } from './usuarios/criar-usuario/criar-usuario.component';
import { CriarClienteComponent } from './clientes/criar-cliente/criar-cliente.component';
import { AtualizarClienteComponent } from './clientes/atualizar-cliente/atualizar-cliente.component';
import { AtualizarProdutoComponent } from './produtos/atualizar-produto/atualizar-produto.component';
import { AuthGuard } from './service/auth.guard';
import { ContratosComponent } from './contratos/contratos.component';
import { CriarContratoComponent } from './contratos/criar-contrato/criar-contrato.component';
import { AtualizarContratoComponent } from './contratos/atualizar-contrato/atualizar-contrato.component';
import { PesquisaComponent } from './pesquisa/pesquisa.component';
import { PesquisaCadastrarComponent } from './pesquisa/pesquisa-cadastrar/pesquisa-cadastrar.component';
import { AgrupamentosComponent } from './agrupamentos/agrupamentos.component';
import { CriarAgrupamentosComponent } from './agrupamentos/criar-agrupamentos/criar-agrupamentos.component';
import { AtualizarAgrupamentoComponent } from './agrupamentos/atualizar-agrupamento/atualizar-agrupamento.component';
import { LicencaComponent } from './licenca/licenca.component';
import { CadastrarLicencaComponent } from './licenca/cadastrar-licenca/cadastrar-licenca.component';
import { AdquirirLicencaComponent } from './licenca/adquirir-licenca/adquirir-licenca.component';
import { AlterarLicencaAdquiridaComponent } from './licenca/alterar-licenca-adquirida/alterar-licenca-adquirida.component';
import { AgviewsConnectComponent } from './agviews-connect/agviews-connect.component';
import { AgviewsConnectAtualizarComponent } from './agviews-connect/agviews-connect-atualizar/agviews-connect-atualizar.component';
import { SsoCallbackComponent } from './sso-callback/sso-callback.component';
import { ShapesComponent } from './shapes/shapes.component';
import { CadastrarShapeComponent } from './shapes/cadastrar-shape/cadastrar-shape.component';

const routes: Routes = [
  {path:'redirect/:token', component: RedirectComponent},
  {path: '', redirectTo: 'home', pathMatch: 'full'},
  {path: 'home',  component: HomeComponent, canActivate: [AuthGuard]},
  {path: 'configuracao',
    component: ConfiguracaoComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {path: "usuarios",component: UsuariosComponent,},
      {path: "usuarios/cadastro",component: CriarUsuarioComponent, data: {permissao: ['cadastro_usuario']}},
      {path: "usuarios/atualizar/:sr_id",component: AtualizarUsuarioComponent, data: {permissao: ['atualizar_usuario']}},

      {path: "grupos",component: GruposComponent, data: {permissao: ['lista_grupos', 'cadastro_grupos', 'atualizar_grupos']}},
      {path: "grupos/cadastro",component: CriarGrupoComponent, data: {permissao: ['cadastro_grupos']}},
      {path: "grupos/atualizar/:sr_id",component: AtualizarGrupoComponent, data: {permissao: ['atualizar_grupos']}},

      {path: "permissoes", component: PermissaoComponent, data: {permissao: ['lista_permissao']}},
      {path: "permissoes/cadastro", component: CriarPermissaoComponent, data: {permissao: ['cadastro_permissao']}},
      {path: "permissoes/atualizar/:sr_id", component: AtualizarPermissaoComponent, data: {permissao: ['atualizar_permissao']}},

      {path: "clientes", component: ClientesComponent, data: {permissao: ['lista_cliente', 'cadastro_cliente', 'atualizar_cliente']}},
      {path: "clientes/cadastro", component: CriarClienteComponent, data: {permissao: ['cadastro_cliente']}},
      {path: "clientes/atualizar/:sr_id", component: AtualizarClienteComponent, data: {permissao: ['atualizar_cliente']}},

      {path: "shapes", component: ShapesComponent, data: {permissao: ['acessar_shapes']}},
      {path: "shapes/cadastro", component: CadastrarShapeComponent, data: {permissao: ['alteracoes_shapes']}},

      {path: "agviewsConnect", component: AgviewsConnectComponent, data: {permissao: ['listar_agviews_connect']}},
      {path: "agviewsConnect/atualizar/:sr_id", component: AgviewsConnectAtualizarComponent, data: {permissao: ['editar_agviews_connect']}},

      {path: "produtos", component: ProdutosComponent, data: {permissao: ['lista_produto']}},
      {path: "produtos/cadastro", component: CriarProdutoComponent, data: {permissao: ['cadastro_produto']}},
      {path: "produtos/atualizar/:sr_id", component: AtualizarProdutoComponent, data: {permissao: ['atualizar_produto']}},

      {path: "contratos", component: ContratosComponent, data: {permissao: ['lista_contrato']}},
      {path: "contratos/cadastro", component: CriarContratoComponent, data: {permissao: ['cadastra_contrato']}},
      {path: "contratos/atualizar/:sr_id", component: AtualizarContratoComponent, data: {permissao: ['edita_contrato']}},

      {path: "pesquisa", component: PesquisaComponent},
      {path: "pesquisa/cadastro", component: PesquisaCadastrarComponent},

      { path: "agrupamentos", component: AgrupamentosComponent, data: { permissao: ['lista_todos_agrupamento', 'lista_agrupamento'] } },
      { path: "agrupamentos/cadastro", component: CriarAgrupamentosComponent, data: { permissao: ['cadastro_agrupamento'] } },
      { path: "agrupamentos/atualizar/:id", component: AtualizarAgrupamentoComponent, data: { permissao: ['atualizar_agrupamento'] } },
      
      { path: "licencas", component: LicencaComponent, data: { permissao: ['acessar_licencas'] }},
      { path: "licencas/cadastro", component: CadastrarLicencaComponent, data: { permissao: ['cadastrar_licenca'] }},
      { path: "licencas/adquirirLicenca", component: AdquirirLicencaComponent, data: { permissao: ['adquirir_licenca'] }},
      { path: "licencas/alterarLicencaAdquirida/:tipoAlteracao", component: AlterarLicencaAdquiridaComponent, data: { permissao: ['atualizar_estado_licencas_adquiridas'] }},
    ],
  },
  {path: '', redirectTo: 'login', pathMatch: 'full'},
  {path: 'login',  component: LoginComponent},
  {path:'recuperar-senha/:token',component: RecuperarSenhaComponent},
  {path:'nova-senha',component: SolicitarNovaSenhaComponent},
  {path: 'sso-callback', component: SsoCallbackComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
